import React from 'react'
import { useTrans, useTransRoute } from 'hooks'
import { ClienteNode, PaginaNode } from '@gql/graphql'
import { GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './ContattaRivenditoreThankYouTemplate.module.sass'
import { Button, WContainer } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  rivenditore?: ClienteNode
}

const ContattaRivenditoreThankYouTemplate = (props: Props) => {
  const { pagina = undefined, rivenditore = undefined } = props

  const t = useTrans()
  const tr = useTransRoute()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={{
            ...pagina,
            descrizione: t('Il punto vendita che stai contattando è: <b>{0}</b>', [
              rivenditore
                ? `${rivenditore.nome} ${rivenditore.indirizzo}, ${rivenditore.cap} ${rivenditore.citta} ${rivenditore.provincia}`
                : '',
            ]),
          }}
        />
        <WContainer>
          <div className={styles.layout}>
            <h2 className={styles.title}>{t('Il tuo messaggio è stato inviato con successo!')}</h2>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: t(
                  'Ti risponderemo entro qualche giorno lavorativo, nel frattempo visita le nostre collezioni o scopri gli altri punti vendita.'
                ),
              }}
            />
            <div className={styles.ctaBox}>
              <Button
                variant="secondary"
                label={t('Scopri tutti i rivenditori')}
                size="lg"
                href={tr('/rivenditori')?.href}
              />
              <Button
                variant="primary"
                label={t('Le nostre collezioni')}
                size="lg"
                href={tr('/collezioni')?.href}
              />
            </div>
          </div>
        </WContainer>
        <Prefooter skipRivenditore />
      </main>
    </Page>
  )
}

export default ContattaRivenditoreThankYouTemplate
